export const MAIN_CONTENT_ID = "main-content"
export const PIED_DE_PAGE_ID = "pied-de-page"
